import $ from 'jquery'

const swap = (input, label) => {
  if (input.val() && input.hasClass('empty')) {
    input.removeClass('empty')
    label.text(label.data('original-text'))
  } else if (!input.val() && !input.hasClass('empty')) {
    input.addClass('empty')
    label.text(label.data('placeholder-text'))
  }
}

export default {
  inserted (el) {
    let input = $(el)
    let label = input.siblings('label')

    if (input.next(label).length === 0) {
      input.closest('.form-group').find('label').remove()
      input.after(label)
    }

    let placeholder = (input.attr('placeholder') && input.attr('placeholder') !== label.text()) ? input.attr('placeholder') : label.text()

    label.data('placeholder-text', placeholder)
    label.data('original-text', label.text())

    swap(input, label)
  },

  update (el) {
    let input = $(el)
    let label = input.siblings('label')

    setTimeout(() => (swap(input, label)), 0)
  }
}



// WEBPACK FOOTER //
// ./src/directives/float-label.js